export const startCtxUI = () => ({
  type: 'START'
});


export const susResAudioCtx = () => ({
  type: 'TOGGLE_CTX_RUNNING'
});


export const closeCtxUI = () => ({
  type: 'CLOSE'
});



// WEBPACK FOOTER //
// ./src/actions.js